import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from "../../../basic/dialog.tsx";
import {Button} from "../../../basic/button.tsx";
import {CheckCircle2, LayoutGrid, Users} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface PaymentSuccessDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function PaymentSuccessDialog({open, onOpenChange}: PaymentSuccessDialogProps) {
    const navigate = useNavigate();
    const {t} = useTranslationWithKeys();

    const handleViewLicenses = () => {
        onOpenChange(false);
        navigate("/licenses");
    };

    const handleAssignToTeam = () => {
        onOpenChange(false);
        navigate("/team");
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <div className="flex items-center justify-center mb-4">
                        <div className="h-16 w-16 rounded-full bg-green-500/10 flex items-center justify-center">
                            <CheckCircle2 className="h-8 w-8 text-green-500"/>
                        </div>
                    </div>
                    <DialogTitle className="text-center text-2xl">
                        {t('payment.success.title')}
                    </DialogTitle>
                    <DialogDescription className="text-center pt-2">
                        {t('payment.success.message')}
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-6 py-4">
                    <p className="text-center text-muted-foreground">
                        {t('payment.success.description')}
                    </p>

                    <div className="flex flex-col sm:flex-row gap-3">
                        <Button
                            variant="outline"
                            className="flex-1 rounded-full"
                            onClick={handleViewLicenses}
                        >
                            <LayoutGrid className="h-4 w-4 mr-2"/>
                            {t('payment.success.viewLicenses')}
                        </Button>
                        <Button
                            className="flex-1 rounded-full"
                            onClick={handleAssignToTeam}
                        >
                            <Users className="h-4 w-4 mr-2"/>
                            {t('payment.success.assignToTeam')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
